import type { AxiosInstance } from "axios";
import type { AuthenticationService } from "../backend/types";
import { createAxiosInstance } from "./configuration";

let apis: {
  backendAPIClient: AxiosInstance;
  supportAPIClient: AxiosInstance;
  loginAPIClient: AxiosInstance;
  mockAPIClient: AxiosInstance;
};

const MOCK_API_ENDPOINT = "http://localhost:3004/";

const getEnglishExamsLabAPIEndpoint = (): string => {
  if (!process.env.REACT_APP_BACKEND_API) {
    throw new Error("REACT_APP_BACKEND_API environment variable is not defined");
  }
  return process.env.REACT_APP_BACKEND_API;
};

const getEnglishExamsLabSupportAPIEndpoint = (): string => {
  if (!process.env.REACT_APP_SUPPORT_API) {
    throw new Error("REACT_APP_SUPPORT_API environment variable is not defined");
  }
  return process.env.REACT_APP_SUPPORT_API;
};

export const getApiClients = (authenticationService: AuthenticationService) => {
  if (!apis) {
    const { axiosInstance: backendAPIClient } = createAxiosInstance(getEnglishExamsLabAPIEndpoint(), {
      getJwtToken: authenticationService.getJwtToken,
      resetJwtToken: authenticationService.resetJwtToken,
      getCognitoUser: authenticationService.getCognitoUser,
    });

    const { axiosInstance: supportAPIClient } = createAxiosInstance(getEnglishExamsLabSupportAPIEndpoint(), {
      getJwtToken: authenticationService.getJwtToken,
      resetJwtToken: authenticationService.resetJwtToken,
      getCognitoUser: authenticationService.getCognitoUser,
    });

    const { axiosInstance: loginAPIClient } = createAxiosInstance(getEnglishExamsLabAPIEndpoint());
    // Add static Authorization header for login client
    loginAPIClient.defaults.headers.common.Authorization = process.env.REACT_APP_AUTH_API_KEY;

    const { axiosInstance: mockAPIClient } = createAxiosInstance(MOCK_API_ENDPOINT);

    apis = { backendAPIClient, supportAPIClient, loginAPIClient, mockAPIClient };
  }
  return apis;
};
